import React from "react";
// import PropTypes from "prop-types";
import {
  Box,
  Snackbar,
  SnackbarContent,
  Typography,
  makeStyles,
} from "@material-ui/core";
import NotificationsRoundedIcon from "@material-ui/icons/NotificationsRounded";
import CheckCircleRoundedIcon from "@material-ui/icons/CheckCircleRounded";
import ErrorRoundedIcon from "@material-ui/icons/ErrorRounded";
import CancelRoundedIcon from "@material-ui/icons/CancelRounded";
import { useDispatch, useSelector } from "react-redux";
import { hideNotification } from "../../redux/features/notification/actions";
// eslint-disable-next-line no-unused-vars
import { NOTIFICATION_ACTIONS, NOTIFICATION_TYPE } from "../../constants";

const useStyles = makeStyles((theme) => ({
  snackbarContent: {
    "&.MuiSnackbarContent-root": {
      padding: 0,
      borderRadius: theme.spacing(2),
    },
    "& .MuiSnackbarContent-message": {
      padding: 0,
    },
  },
  notification: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    // width: "400px", // Adjust width as needed
    // backgroundColor: '#2D2D2E',
    color: theme.palette.common.white,
    padding: theme.spacing(1),
    // maxWidth: "200px",
    width: "100%", // Set default width to 100%
    [theme.breakpoints.up("sm")]: {
      // For screens larger than small (sm) breakpoint
      // width: "200px", // Adjust width as needed
    },
    position: "relative", // Added position relative
  },
  iconSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "20%", // Width for the first section
  },
  icon: {
    fontSize: theme.spacing(4), // Adjust icon size as needed
    marginRight: "5px", // Adjust icon margin as needed
  },
  subSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "100%", // Adjust width for the first section
    marginRight: theme.spacing(2),
    position: "relative", // Added position relative
    whiteSpace: "wrap", // Prevent text from wrapping
    color: theme.palette.common.black,
  },
  verticalLine: {
    width: "1px",
    height: "100%",
    backgroundColor: theme.palette.common.white,
    position: "absolute",
    left: "75%", // Separator between sections
    top: "0",
  },
  horizontalFromVertical: {
    width: "25%", // Width for the second section
    height: "1px",
    backgroundColor: theme.palette.common.white,
    position: "absolute",
    top: "50%",
    left: "75%",
    // left: 'calc(85% + 0px)', // Separator between sections
    // transform: 'translate(-50%, -50%)',
  },
  secondSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "30%", // Width for the second section
    padding: "0 10px",
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    color:theme.palette.common.white,
    marginBottom: "5px",
  },
  warning: {
    backgroundColor: "#ffe487", // Use your warning color from theme
  },
  error: {
    backgroundColor: "#fd809f", // Use your error color from theme
  },
  success: {
    backgroundColor: "#5db792",
  },
  notificationColor: {
    backgroundColor: "#ccced7",
  },
  subTitle:{
    color:theme.palette.common.white,
  }
}));

const Notification = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const notification = useSelector((state) => state.notification);

  const handleClose = () => {
    dispatch(hideNotification());
  };

  let icon = null;
  // let primaryAction = NOTIFICATION_ACTIONS.INFO;
  // let secondaryAction = NOTIFICATION_ACTIONS.CLOSE;
  // let hideHorizontalLine = false;
  let snackbarClass = "";

  switch (notification?.type) {
    case NOTIFICATION_TYPE.SUCCESS:
      icon = <CheckCircleRoundedIcon className={classes.icon} />;
      // primaryAction = "";
      // secondaryAction = NOTIFICATION_ACTIONS.CLOSE; // No secondary action for SUCCESS
      // hideHorizontalLine = true; // Hide horizontal line for SUCCESS
      snackbarClass = classes.success;
      break;
    case NOTIFICATION_TYPE.ERROR:
      icon = <CancelRoundedIcon className={classes.icon} />;
      // primaryAction = NOTIFICATION_ACTIONS.INFO;
      // secondaryAction = NOTIFICATION_ACTIONS.CLOSE;
      snackbarClass = classes.error;
      break;
    case NOTIFICATION_TYPE.WARNING:
      icon = <ErrorRoundedIcon className={classes.icon} />;
      // primaryAction = NOTIFICATION_ACTIONS.RETRY;
      // secondaryAction = NOTIFICATION_ACTIONS.CLOSE;
      snackbarClass = classes.warning;
      // primaryAction = "";
      // hideHorizontalLine = true;
      break;
    case NOTIFICATION_TYPE.INFO:
      icon = <ErrorRoundedIcon className={classes.icon} />;
      // primaryAction = NOTIFICATION_ACTIONS.RETRY;
      // secondaryAction = NOTIFICATION_ACTIONS.CLOSE;
      snackbarClass = classes.warning;
      break;
    case NOTIFICATION_TYPE.NOTIFICATION:
      icon = <NotificationsRoundedIcon className={classes.icon} />;
      // primaryAction = NOTIFICATION_ACTIONS.REFRESH;
      // secondaryAction = NOTIFICATION_ACTIONS.CLOSE;
      snackbarClass = classes.notificationColor;
      break;
    default:
      break;
  }

  // const handlePrimaryAction = (actionType, actionFunction) => {
  //   if (notification.type === NOTIFICATION_TYPE.SUCCESS) {
  //     // Handle success primary action
  //   } else if (notification.type === NOTIFICATION_TYPE.ERROR) {
  //     // Handle error primary action
  //   } else if (
  //     notification.type === NOTIFICATION_TYPE.WARNING ||
  //     notification.type === NOTIFICATION_TYPE.INFO
  //   ) {
  //     // Handle warning or info primary action
  //   } else if (notification.type === NOTIFICATION_TYPE.INFO) {
  //     // Handle notification primary action
  //   } else if (notification.type === NOTIFICATION_TYPE.NOTIFICATION) {
  //     // Handle notification primary action
  //   }
  //   if (actionFunction) {
  //     actionFunction(primaryAction);
  //   }
  //   // handleClose();
  //   // Pass actionType to the parent component
  //   return actionType;
  // };

  // const handleSecondaryAction = () => {
  //   handleClose();
  // };

  return (
    <Snackbar
      open={notification?.open}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      autoHideDuration={2000}
      onClose={handleClose}
      // ContentProps={{
      //   className: snackbarClass,
      // }}
    >
      <SnackbarContent
        className={`${classes.snackbarContent} ${snackbarClass}`}
        message={
          <Box className={classes.notification}>
            <Box className={classes.iconSection}>{icon}</Box>
            <Box className={classes.subSection}>
              <Typography variant="subtitle1" className={classes.title}>
                {notification?.title}
              </Typography>
              <Typography variant="body2" className={classes.subTitle}>{notification?.subtitle}</Typography>
            </Box>
            {/* <Box className={classes.verticalLine} />
            {hideHorizontalLine ? null : (
              <Box className={classes.horizontalFromVertical} />
            )}
            <Box className={classes.secondSection}>
              <Box
                style={{
                  paddingBottom: !hideHorizontalLine ? "10px" : "0px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  // const actionType =
                  handlePrimaryAction(
                    notification?.type,
                    notification.primaryAction
                  ); // Pass the type as actionType
                  // handleClose(actionType); // Send the actionType back to the parent component
                }}
              >
                {primaryAction}
              </Box>
              {secondaryAction && (
                <Box
                  style={{ paddingTop: "10px", cursor: "pointer" }}
                  onClick={handleSecondaryAction}
                >
                  {secondaryAction}
                </Box>
              )}
            </Box> */}
          </Box>
        }
      />
    </Snackbar>
  );
};

export default Notification;
